import { Injectable, Inject } from '@angular/core';
import {LoiHttpClient} from 'loi-lti-common';
import { Observable } from 'rxjs';
import { LtiResponseModel } from '../models/lti-response.model';
import { Cacheable } from 'ngx-cacheable';

const httpFormOptions = {};

@Injectable({
  providedIn: 'root'
})
export class LtiRequestService {
  constructor(private loiHttpClient: LoiHttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  @Cacheable()
  getLtiRequest(): Observable<LtiResponseModel> {
    return this.loiHttpClient.get<LtiResponseModel>(`${this.baseUrl}LtiRequest`);
  }
}
